module.exports = __webpack_public_path__ + "img/xm.f0721f41.jpg";